// extracted by mini-css-extract-plugin
export default {"news":"singleProjectToDelete_news__1StJk","titel":"singleProjectToDelete_titel__EhyHh"};